import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import { afterAddToHomeScreenClose } from 'src/modules/App/actions'
import AddToHomeScreen from './AddToHomeScreen'

const mapStateToProps = (state) => {
  return {
    brand: getFromSettings(state, 'brand', {}),
    graphics: getFromSettings(state, 'graphics', {}),
    isAddToHomeScreenClosed: state.appReducer.isAddToHomeScreenClosed,
  }
}

const mapDispatchToProps = {
  afterAddToHomeScreenClose,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToHomeScreen)
